<div class="flex flex-col gap-2">
  @for (schedule of schedules(); track schedule.data?.id) {
    <div
      class="flex border border-surface-3 bg-surface-2 rounded-2xl p-4 gap-4">
      <div
        class="flex items-center justify-center h-10 w-10 rounded-lg" [ngClass]="{
          'bg-primary/20': schedule.data?.enabled,
          'bg-surface-3': !schedule.data?.enabled,
        }">
        <i class="pi pi-clock text-xl!" [ngClass]="{
          'text-primary-light': schedule.data?.enabled,
          'text-subtle': !schedule.data?.enabled,
        }"></i>
      </div>
      <div class="flex flex-col grow">
        <h3 class="font-medium text-primary">{{ schedule.data?.name }}</h3>
        <small class="text-subtle">{{ schedule.data?.description }}</small>
        <div class="flex gap-1 items-center mt-3">
          <i class="pi pi-clock text-subtle text-xs!"></i>
          <span class="text-subtle text-sm">{{
            translateCronExpression(schedule.data!.cronExpression)
          }}</span>
        </div>
      </div>
      <div class="flex gap-2 items-center" [formGroup]="scheduleFormGroup(schedule.data!)">
          <v-switch fControlName="enabled"></v-switch>
        <v-dropdown-menu
          [menuItems]="getMenuItems(schedule.data!)"></v-dropdown-menu>
      </div>
    </div>
  }
</div>
